import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when route changes
    // Using instant scroll for better UX when navigating between pages
    window.scrollTo(0, 0);
    
    // Alternative smooth scroll (commented out for better performance)
    // window.scrollTo({
    //   top: 0,
    //   left: 0,
    //   behavior: 'smooth'
    // });
  }, [pathname]);

  return null;
};

export default ScrollToTop;